import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { useCallback } from 'react';

export const useEpisodeUrl = () => {
  const router = useRouter();
  const { lang } = useTranslation();

  const getCleanPathname = useCallback(() => {
    return `/${lang}${router.pathname.replace('(v2)/', '')}`;
  }, [lang, router.pathname]);

  const clearEpisodeFromUrl = useCallback(() => {
    const query = { ...router.query };
    delete query.id;

    router.push(
      {
        pathname: getCleanPathname(),
        query: query,
      },
      undefined,
      { shallow: true }
    );
  }, [getCleanPathname, router]);

  const setEpisodeInUrl = useCallback(
    (episodeId: number) => {
      router.push(
        {
          pathname: getCleanPathname(),
          query: {
            ...router.query,
            id: episodeId,
          },
        },
        undefined,
        { shallow: true }
      );
    },
    [getCleanPathname, router]
  );

  return {
    clearEpisodeFromUrl,
    setEpisodeInUrl,
  };
};

export default useEpisodeUrl;
